/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createDevice = /* GraphQL */ `
  mutation CreateDevice(
    $input: CreateDeviceInput!
    $condition: ModelDeviceConditionInput
  ) {
    createDevice(input: $input, condition: $condition) {
      id
      serial
      type
      version
      owner
      name
      privateAudio
      shareLink
      shareBird
      shareMarine
      hideOnMap
      collectSoundscape
      createdAt
      updatedAt
      lat
      lon
      tzOffsetMinutes
      tz
      smsPhone1
      smsPhone2
      smsTimeStart
      smsTimeStop
      smsPause
      newBirdAlert
      __typename
    }
  }
`;
export const updateDevice = /* GraphQL */ `
  mutation UpdateDevice(
    $input: UpdateDeviceInput!
    $condition: ModelDeviceConditionInput
  ) {
    updateDevice(input: $input, condition: $condition) {
      id
      serial
      type
      version
      owner
      name
      privateAudio
      shareLink
      shareBird
      shareMarine
      hideOnMap
      collectSoundscape
      createdAt
      updatedAt
      lat
      lon
      tzOffsetMinutes
      tz
      smsPhone1
      smsPhone2
      smsTimeStart
      smsTimeStop
      smsPause
      newBirdAlert
      __typename
    }
  }
`;
export const deleteDevice = /* GraphQL */ `
  mutation DeleteDevice(
    $input: DeleteDeviceInput!
    $condition: ModelDeviceConditionInput
  ) {
    deleteDevice(input: $input, condition: $condition) {
      id
      serial
      type
      version
      owner
      name
      privateAudio
      shareLink
      shareBird
      shareMarine
      hideOnMap
      collectSoundscape
      createdAt
      updatedAt
      lat
      lon
      tzOffsetMinutes
      tz
      smsPhone1
      smsPhone2
      smsTimeStart
      smsTimeStop
      smsPause
      newBirdAlert
      __typename
    }
  }
`;
export const createDeviceHistory = /* GraphQL */ `
  mutation CreateDeviceHistory(
    $input: CreateDeviceHistoryInput!
    $condition: ModelDeviceHistoryConditionInput
  ) {
    createDeviceHistory(input: $input, condition: $condition) {
      id
      serial
      version
      owner
      name
      shareBird
      createDate
      createdAt
      updatedAt
      lat
      lon
      deviceAction
      __typename
    }
  }
`;
export const updateDeviceHistory = /* GraphQL */ `
  mutation UpdateDeviceHistory(
    $input: UpdateDeviceHistoryInput!
    $condition: ModelDeviceHistoryConditionInput
  ) {
    updateDeviceHistory(input: $input, condition: $condition) {
      id
      serial
      version
      owner
      name
      shareBird
      createDate
      createdAt
      updatedAt
      lat
      lon
      deviceAction
      __typename
    }
  }
`;
export const deleteDeviceHistory = /* GraphQL */ `
  mutation DeleteDeviceHistory(
    $input: DeleteDeviceHistoryInput!
    $condition: ModelDeviceHistoryConditionInput
  ) {
    deleteDeviceHistory(input: $input, condition: $condition) {
      id
      serial
      version
      owner
      name
      shareBird
      createDate
      createdAt
      updatedAt
      lat
      lon
      deviceAction
      __typename
    }
  }
`;
export const createHit = /* GraphQL */ `
  mutation CreateHit(
    $input: CreateHitInput!
    $condition: ModelHitConditionInput
  ) {
    createHit(input: $input, condition: $condition) {
      id
      serial
      dt
      group
      cn
      sn
      spCode
      wav
      lat
      lon
      score
      specSum
      version
      detectionArray
      detectionConfidence
      detectionCount
      type
      labeledBy
      label
      human
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateHit = /* GraphQL */ `
  mutation UpdateHit(
    $input: UpdateHitInput!
    $condition: ModelHitConditionInput
  ) {
    updateHit(input: $input, condition: $condition) {
      id
      serial
      dt
      group
      cn
      sn
      spCode
      wav
      lat
      lon
      score
      specSum
      version
      detectionArray
      detectionConfidence
      detectionCount
      type
      labeledBy
      label
      human
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteHit = /* GraphQL */ `
  mutation DeleteHit(
    $input: DeleteHitInput!
    $condition: ModelHitConditionInput
  ) {
    deleteHit(input: $input, condition: $condition) {
      id
      serial
      dt
      group
      cn
      sn
      spCode
      wav
      lat
      lon
      score
      specSum
      version
      detectionArray
      detectionConfidence
      detectionCount
      type
      labeledBy
      label
      human
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createHitNotInGrid = /* GraphQL */ `
  mutation CreateHitNotInGrid(
    $input: CreateHitNotInGridInput!
    $condition: ModelHitNotInGridConditionInput
  ) {
    createHitNotInGrid(input: $input, condition: $condition) {
      id
      serial
      dt
      group
      cn
      sn
      spCode
      wav
      latitude
      longitude
      score
      specSum
      version
      detectionArrayF
      detectionConfidenceF
      detectionArrayUf
      detectionConfidenceUf
      detectionCount
      type
      labeledBy
      label
      human
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateHitNotInGrid = /* GraphQL */ `
  mutation UpdateHitNotInGrid(
    $input: UpdateHitNotInGridInput!
    $condition: ModelHitNotInGridConditionInput
  ) {
    updateHitNotInGrid(input: $input, condition: $condition) {
      id
      serial
      dt
      group
      cn
      sn
      spCode
      wav
      latitude
      longitude
      score
      specSum
      version
      detectionArrayF
      detectionConfidenceF
      detectionArrayUf
      detectionConfidenceUf
      detectionCount
      type
      labeledBy
      label
      human
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteHitNotInGrid = /* GraphQL */ `
  mutation DeleteHitNotInGrid(
    $input: DeleteHitNotInGridInput!
    $condition: ModelHitNotInGridConditionInput
  ) {
    deleteHitNotInGrid(input: $input, condition: $condition) {
      id
      serial
      dt
      group
      cn
      sn
      spCode
      wav
      latitude
      longitude
      score
      specSum
      version
      detectionArrayF
      detectionConfidenceF
      detectionArrayUf
      detectionConfidenceUf
      detectionCount
      type
      labeledBy
      label
      human
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDeviceState = /* GraphQL */ `
  mutation CreateDeviceState(
    $input: CreateDeviceStateInput!
    $condition: ModelDeviceStateConditionInput
  ) {
    createDeviceState(input: $input, condition: $condition) {
      id
      serial
      type
      lat
      lon
      timezone
      connected
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDeviceState = /* GraphQL */ `
  mutation UpdateDeviceState(
    $input: UpdateDeviceStateInput!
    $condition: ModelDeviceStateConditionInput
  ) {
    updateDeviceState(input: $input, condition: $condition) {
      id
      serial
      type
      lat
      lon
      timezone
      connected
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDeviceState = /* GraphQL */ `
  mutation DeleteDeviceState(
    $input: DeleteDeviceStateInput!
    $condition: ModelDeviceStateConditionInput
  ) {
    deleteDeviceState(input: $input, condition: $condition) {
      id
      serial
      type
      lat
      lon
      timezone
      connected
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createBootTable = /* GraphQL */ `
  mutation CreateBootTable(
    $input: CreateBootTableInput!
    $condition: ModelBootTableConditionInput
  ) {
    createBootTable(input: $input, condition: $condition) {
      id
      serial
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateBootTable = /* GraphQL */ `
  mutation UpdateBootTable(
    $input: UpdateBootTableInput!
    $condition: ModelBootTableConditionInput
  ) {
    updateBootTable(input: $input, condition: $condition) {
      id
      serial
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteBootTable = /* GraphQL */ `
  mutation DeleteBootTable(
    $input: DeleteBootTableInput!
    $condition: ModelBootTableConditionInput
  ) {
    deleteBootTable(input: $input, condition: $condition) {
      id
      serial
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createStatusTable = /* GraphQL */ `
  mutation CreateStatusTable(
    $input: CreateStatusTableInput!
    $condition: ModelStatusTableConditionInput
  ) {
    createStatusTable(input: $input, condition: $condition) {
      id
      serial
      cpuTemp
      cpuFreq
      warning
      ramdisk
      signal
      availMem
      pyMem
      gridLength
      nDirect
      nCloud
      freeGB
      lat
      lon
      V
      ovf
      postTime
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateStatusTable = /* GraphQL */ `
  mutation UpdateStatusTable(
    $input: UpdateStatusTableInput!
    $condition: ModelStatusTableConditionInput
  ) {
    updateStatusTable(input: $input, condition: $condition) {
      id
      serial
      cpuTemp
      cpuFreq
      warning
      ramdisk
      signal
      availMem
      pyMem
      gridLength
      nDirect
      nCloud
      freeGB
      lat
      lon
      V
      ovf
      postTime
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteStatusTable = /* GraphQL */ `
  mutation DeleteStatusTable(
    $input: DeleteStatusTableInput!
    $condition: ModelStatusTableConditionInput
  ) {
    deleteStatusTable(input: $input, condition: $condition) {
      id
      serial
      cpuTemp
      cpuFreq
      warning
      ramdisk
      signal
      availMem
      pyMem
      gridLength
      nDirect
      nCloud
      freeGB
      lat
      lon
      V
      ovf
      postTime
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createLogTable = /* GraphQL */ `
  mutation CreateLogTable(
    $input: CreateLogTableInput!
    $condition: ModelLogTableConditionInput
  ) {
    createLogTable(input: $input, condition: $condition) {
      id
      serial
      log
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateLogTable = /* GraphQL */ `
  mutation UpdateLogTable(
    $input: UpdateLogTableInput!
    $condition: ModelLogTableConditionInput
  ) {
    updateLogTable(input: $input, condition: $condition) {
      id
      serial
      log
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteLogTable = /* GraphQL */ `
  mutation DeleteLogTable(
    $input: DeleteLogTableInput!
    $condition: ModelLogTableConditionInput
  ) {
    deleteLogTable(input: $input, condition: $condition) {
      id
      serial
      log
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createExceptionTable = /* GraphQL */ `
  mutation CreateExceptionTable(
    $input: CreateExceptionTableInput!
    $condition: ModelExceptionTableConditionInput
  ) {
    createExceptionTable(input: $input, condition: $condition) {
      id
      serial
      exception
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateExceptionTable = /* GraphQL */ `
  mutation UpdateExceptionTable(
    $input: UpdateExceptionTableInput!
    $condition: ModelExceptionTableConditionInput
  ) {
    updateExceptionTable(input: $input, condition: $condition) {
      id
      serial
      exception
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteExceptionTable = /* GraphQL */ `
  mutation DeleteExceptionTable(
    $input: DeleteExceptionTableInput!
    $condition: ModelExceptionTableConditionInput
  ) {
    deleteExceptionTable(input: $input, condition: $condition) {
      id
      serial
      exception
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDailyCount = /* GraphQL */ `
  mutation CreateDailyCount(
    $input: CreateDailyCountInput!
    $condition: ModelDailyCountConditionInput
  ) {
    createDailyCount(input: $input, condition: $condition) {
      id
      serial
      date
      group
      cn
      sn
      spCode
      count
      lat
      lon
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDailyCount = /* GraphQL */ `
  mutation UpdateDailyCount(
    $input: UpdateDailyCountInput!
    $condition: ModelDailyCountConditionInput
  ) {
    updateDailyCount(input: $input, condition: $condition) {
      id
      serial
      date
      group
      cn
      sn
      spCode
      count
      lat
      lon
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDailyCount = /* GraphQL */ `
  mutation DeleteDailyCount(
    $input: DeleteDailyCountInput!
    $condition: ModelDailyCountConditionInput
  ) {
    deleteDailyCount(input: $input, condition: $condition) {
      id
      serial
      date
      group
      cn
      sn
      spCode
      count
      lat
      lon
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createHourlyCount = /* GraphQL */ `
  mutation CreateHourlyCount(
    $input: CreateHourlyCountInput!
    $condition: ModelHourlyCountConditionInput
  ) {
    createHourlyCount(input: $input, condition: $condition) {
      id
      serial
      date
      group
      cn
      sn
      spCode
      count
      lat
      lon
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateHourlyCount = /* GraphQL */ `
  mutation UpdateHourlyCount(
    $input: UpdateHourlyCountInput!
    $condition: ModelHourlyCountConditionInput
  ) {
    updateHourlyCount(input: $input, condition: $condition) {
      id
      serial
      date
      group
      cn
      sn
      spCode
      count
      lat
      lon
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteHourlyCount = /* GraphQL */ `
  mutation DeleteHourlyCount(
    $input: DeleteHourlyCountInput!
    $condition: ModelHourlyCountConditionInput
  ) {
    deleteHourlyCount(input: $input, condition: $condition) {
      id
      serial
      date
      group
      cn
      sn
      spCode
      count
      lat
      lon
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createLabeledData = /* GraphQL */ `
  mutation CreateLabeledData(
    $input: CreateLabeledDataInput!
    $condition: ModelLabeledDataConditionInput
  ) {
    createLabeledData(input: $input, condition: $condition) {
      id
      serial
      dt
      group
      cn
      sn
      spCode
      wav
      labeledBy
      label
      score
      lat
      lon
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateLabeledData = /* GraphQL */ `
  mutation UpdateLabeledData(
    $input: UpdateLabeledDataInput!
    $condition: ModelLabeledDataConditionInput
  ) {
    updateLabeledData(input: $input, condition: $condition) {
      id
      serial
      dt
      group
      cn
      sn
      spCode
      wav
      labeledBy
      label
      score
      lat
      lon
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteLabeledData = /* GraphQL */ `
  mutation DeleteLabeledData(
    $input: DeleteLabeledDataInput!
    $condition: ModelLabeledDataConditionInput
  ) {
    deleteLabeledData(input: $input, condition: $condition) {
      id
      serial
      dt
      group
      cn
      sn
      spCode
      wav
      labeledBy
      label
      score
      lat
      lon
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDailyCountSummary = /* GraphQL */ `
  mutation CreateDailyCountSummary(
    $input: CreateDailyCountSummaryInput!
    $condition: ModelDailyCountSummaryConditionInput
  ) {
    createDailyCountSummary(input: $input, condition: $condition) {
      id
      serial
      countsPerDay
      cn
      spCode
      lat
      lon
      countDate
      wav
      newBirdAlertAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDailyCountSummary = /* GraphQL */ `
  mutation UpdateDailyCountSummary(
    $input: UpdateDailyCountSummaryInput!
    $condition: ModelDailyCountSummaryConditionInput
  ) {
    updateDailyCountSummary(input: $input, condition: $condition) {
      id
      serial
      countsPerDay
      cn
      spCode
      lat
      lon
      countDate
      wav
      newBirdAlertAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDailyCountSummary = /* GraphQL */ `
  mutation DeleteDailyCountSummary(
    $input: DeleteDailyCountSummaryInput!
    $condition: ModelDailyCountSummaryConditionInput
  ) {
    deleteDailyCountSummary(input: $input, condition: $condition) {
      id
      serial
      countsPerDay
      cn
      spCode
      lat
      lon
      countDate
      wav
      newBirdAlertAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createYearlyCountSummary = /* GraphQL */ `
  mutation CreateYearlyCountSummary(
    $input: CreateYearlyCountSummaryInput!
    $condition: ModelYearlyCountSummaryConditionInput
  ) {
    createYearlyCountSummary(input: $input, condition: $condition) {
      id
      serial
      countsTotal
      cn
      spCode
      lat
      lon
      countYear
      wav
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateYearlyCountSummary = /* GraphQL */ `
  mutation UpdateYearlyCountSummary(
    $input: UpdateYearlyCountSummaryInput!
    $condition: ModelYearlyCountSummaryConditionInput
  ) {
    updateYearlyCountSummary(input: $input, condition: $condition) {
      id
      serial
      countsTotal
      cn
      spCode
      lat
      lon
      countYear
      wav
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteYearlyCountSummary = /* GraphQL */ `
  mutation DeleteYearlyCountSummary(
    $input: DeleteYearlyCountSummaryInput!
    $condition: ModelYearlyCountSummaryConditionInput
  ) {
    deleteYearlyCountSummary(input: $input, condition: $condition) {
      id
      serial
      countsTotal
      cn
      spCode
      lat
      lon
      countYear
      wav
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUserInteraction = /* GraphQL */ `
  mutation CreateUserInteraction(
    $input: CreateUserInteractionInput!
    $condition: ModelUserInteractionConditionInput
  ) {
    createUserInteraction(input: $input, condition: $condition) {
      id
      totalLabeled
      speciesLabeled
      speciesLabeledCode
      totalSpeciesLabeled
      labelStreak
      labelStreakRecord
      dateLastLabeled
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUserInteraction = /* GraphQL */ `
  mutation UpdateUserInteraction(
    $input: UpdateUserInteractionInput!
    $condition: ModelUserInteractionConditionInput
  ) {
    updateUserInteraction(input: $input, condition: $condition) {
      id
      totalLabeled
      speciesLabeled
      speciesLabeledCode
      totalSpeciesLabeled
      labelStreak
      labelStreakRecord
      dateLastLabeled
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUserInteraction = /* GraphQL */ `
  mutation DeleteUserInteraction(
    $input: DeleteUserInteractionInput!
    $condition: ModelUserInteractionConditionInput
  ) {
    deleteUserInteraction(input: $input, condition: $condition) {
      id
      totalLabeled
      speciesLabeled
      speciesLabeledCode
      totalSpeciesLabeled
      labelStreak
      labelStreakRecord
      dateLastLabeled
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createClickTable = /* GraphQL */ `
  mutation CreateClickTable(
    $input: CreateClickTableInput!
    $condition: ModelClickTableConditionInput
  ) {
    createClickTable(input: $input, condition: $condition) {
      id
      userID
      serial
      spCode
      cn
      clickTarget
      pageClickedFrom
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateClickTable = /* GraphQL */ `
  mutation UpdateClickTable(
    $input: UpdateClickTableInput!
    $condition: ModelClickTableConditionInput
  ) {
    updateClickTable(input: $input, condition: $condition) {
      id
      userID
      serial
      spCode
      cn
      clickTarget
      pageClickedFrom
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteClickTable = /* GraphQL */ `
  mutation DeleteClickTable(
    $input: DeleteClickTableInput!
    $condition: ModelClickTableConditionInput
  ) {
    deleteClickTable(input: $input, condition: $condition) {
      id
      userID
      serial
      spCode
      cn
      clickTarget
      pageClickedFrom
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createRawHaikumarine = /* GraphQL */ `
  mutation CreateRawHaikumarine(
    $input: CreateRawHaikumarineInput!
    $condition: ModelRawHaikumarineConditionInput
  ) {
    createRawHaikumarine(input: $input, condition: $condition) {
      id
      serial
      dt
      lat
      lon
      wav
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateRawHaikumarine = /* GraphQL */ `
  mutation UpdateRawHaikumarine(
    $input: UpdateRawHaikumarineInput!
    $condition: ModelRawHaikumarineConditionInput
  ) {
    updateRawHaikumarine(input: $input, condition: $condition) {
      id
      serial
      dt
      lat
      lon
      wav
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteRawHaikumarine = /* GraphQL */ `
  mutation DeleteRawHaikumarine(
    $input: DeleteRawHaikumarineInput!
    $condition: ModelRawHaikumarineConditionInput
  ) {
    deleteRawHaikumarine(input: $input, condition: $condition) {
      id
      serial
      dt
      lat
      lon
      wav
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createGridByLoc = /* GraphQL */ `
  mutation CreateGridByLoc(
    $input: CreateGridByLocInput!
    $condition: ModelGridByLocConditionInput
  ) {
    createGridByLoc(input: $input, condition: $condition) {
      id
      lat
      lon
      week
      spCode
      cn
      sn
      gridName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateGridByLoc = /* GraphQL */ `
  mutation UpdateGridByLoc(
    $input: UpdateGridByLocInput!
    $condition: ModelGridByLocConditionInput
  ) {
    updateGridByLoc(input: $input, condition: $condition) {
      id
      lat
      lon
      week
      spCode
      cn
      sn
      gridName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteGridByLoc = /* GraphQL */ `
  mutation DeleteGridByLoc(
    $input: DeleteGridByLocInput!
    $condition: ModelGridByLocConditionInput
  ) {
    deleteGridByLoc(input: $input, condition: $condition) {
      id
      lat
      lon
      week
      spCode
      cn
      sn
      gridName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createGridBySpCode = /* GraphQL */ `
  mutation CreateGridBySpCode(
    $input: CreateGridBySpCodeInput!
    $condition: ModelGridBySpCodeConditionInput
  ) {
    createGridBySpCode(input: $input, condition: $condition) {
      id
      lat
      lon
      week
      spCode
      cn
      sn
      gridName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateGridBySpCode = /* GraphQL */ `
  mutation UpdateGridBySpCode(
    $input: UpdateGridBySpCodeInput!
    $condition: ModelGridBySpCodeConditionInput
  ) {
    updateGridBySpCode(input: $input, condition: $condition) {
      id
      lat
      lon
      week
      spCode
      cn
      sn
      gridName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteGridBySpCode = /* GraphQL */ `
  mutation DeleteGridBySpCode(
    $input: DeleteGridBySpCodeInput!
    $condition: ModelGridBySpCodeConditionInput
  ) {
    deleteGridBySpCode(input: $input, condition: $condition) {
      id
      lat
      lon
      week
      spCode
      cn
      sn
      gridName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createGridHistory = /* GraphQL */ `
  mutation CreateGridHistory(
    $input: CreateGridHistoryInput!
    $condition: ModelGridHistoryConditionInput
  ) {
    createGridHistory(input: $input, condition: $condition) {
      id
      lat
      lon
      week
      spCode
      cn
      sn
      modType
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateGridHistory = /* GraphQL */ `
  mutation UpdateGridHistory(
    $input: UpdateGridHistoryInput!
    $condition: ModelGridHistoryConditionInput
  ) {
    updateGridHistory(input: $input, condition: $condition) {
      id
      lat
      lon
      week
      spCode
      cn
      sn
      modType
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteGridHistory = /* GraphQL */ `
  mutation DeleteGridHistory(
    $input: DeleteGridHistoryInput!
    $condition: ModelGridHistoryConditionInput
  ) {
    deleteGridHistory(input: $input, condition: $condition) {
      id
      lat
      lon
      week
      spCode
      cn
      sn
      modType
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createHideBird = /* GraphQL */ `
  mutation CreateHideBird(
    $input: CreateHideBirdInput!
    $condition: ModelHideBirdConditionInput
  ) {
    createHideBird(input: $input, condition: $condition) {
      id
      spCode
      cn
      serial
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateHideBird = /* GraphQL */ `
  mutation UpdateHideBird(
    $input: UpdateHideBirdInput!
    $condition: ModelHideBirdConditionInput
  ) {
    updateHideBird(input: $input, condition: $condition) {
      id
      spCode
      cn
      serial
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteHideBird = /* GraphQL */ `
  mutation DeleteHideBird(
    $input: DeleteHideBirdInput!
    $condition: ModelHideBirdConditionInput
  ) {
    deleteHideBird(input: $input, condition: $condition) {
      id
      spCode
      cn
      serial
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createNotifyBird = /* GraphQL */ `
  mutation CreateNotifyBird(
    $input: CreateNotifyBirdInput!
    $condition: ModelNotifyBirdConditionInput
  ) {
    createNotifyBird(input: $input, condition: $condition) {
      id
      spCode
      cn
      serial
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateNotifyBird = /* GraphQL */ `
  mutation UpdateNotifyBird(
    $input: UpdateNotifyBirdInput!
    $condition: ModelNotifyBirdConditionInput
  ) {
    updateNotifyBird(input: $input, condition: $condition) {
      id
      spCode
      cn
      serial
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteNotifyBird = /* GraphQL */ `
  mutation DeleteNotifyBird(
    $input: DeleteNotifyBirdInput!
    $condition: ModelNotifyBirdConditionInput
  ) {
    deleteNotifyBird(input: $input, condition: $condition) {
      id
      spCode
      cn
      serial
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createNotifications = /* GraphQL */ `
  mutation CreateNotifications(
    $input: CreateNotificationsInput!
    $condition: ModelNotificationsConditionInput
  ) {
    createNotifications(input: $input, condition: $condition) {
      id
      serial
      owner
      played
      notificationType
      cn
      spCode
      wav
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateNotifications = /* GraphQL */ `
  mutation UpdateNotifications(
    $input: UpdateNotificationsInput!
    $condition: ModelNotificationsConditionInput
  ) {
    updateNotifications(input: $input, condition: $condition) {
      id
      serial
      owner
      played
      notificationType
      cn
      spCode
      wav
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteNotifications = /* GraphQL */ `
  mutation DeleteNotifications(
    $input: DeleteNotificationsInput!
    $condition: ModelNotificationsConditionInput
  ) {
    deleteNotifications(input: $input, condition: $condition) {
      id
      serial
      owner
      played
      notificationType
      cn
      spCode
      wav
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createOneSignal = /* GraphQL */ `
  mutation CreateOneSignal(
    $input: CreateOneSignalInput!
    $condition: ModelOneSignalConditionInput
  ) {
    createOneSignal(input: $input, condition: $condition) {
      id
      playerID
      platform
      serial
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateOneSignal = /* GraphQL */ `
  mutation UpdateOneSignal(
    $input: UpdateOneSignalInput!
    $condition: ModelOneSignalConditionInput
  ) {
    updateOneSignal(input: $input, condition: $condition) {
      id
      playerID
      platform
      serial
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteOneSignal = /* GraphQL */ `
  mutation DeleteOneSignal(
    $input: DeleteOneSignalInput!
    $condition: ModelOneSignalConditionInput
  ) {
    deleteOneSignal(input: $input, condition: $condition) {
      id
      playerID
      platform
      serial
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createOneSignalConsent = /* GraphQL */ `
  mutation CreateOneSignalConsent(
    $input: CreateOneSignalConsentInput!
    $condition: ModelOneSignalConsentConditionInput
  ) {
    createOneSignalConsent(input: $input, condition: $condition) {
      id
      osConsentGranted
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateOneSignalConsent = /* GraphQL */ `
  mutation UpdateOneSignalConsent(
    $input: UpdateOneSignalConsentInput!
    $condition: ModelOneSignalConsentConditionInput
  ) {
    updateOneSignalConsent(input: $input, condition: $condition) {
      id
      osConsentGranted
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteOneSignalConsent = /* GraphQL */ `
  mutation DeleteOneSignalConsent(
    $input: DeleteOneSignalConsentInput!
    $condition: ModelOneSignalConsentConditionInput
  ) {
    deleteOneSignalConsent(input: $input, condition: $condition) {
      id
      osConsentGranted
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createShareMap = /* GraphQL */ `
  mutation CreateShareMap(
    $input: CreateShareMapInput!
    $condition: ModelShareMapConditionInput
  ) {
    createShareMap(input: $input, condition: $condition) {
      id
      name
      shareLat
      shareLon
      tz
      connected
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateShareMap = /* GraphQL */ `
  mutation UpdateShareMap(
    $input: UpdateShareMapInput!
    $condition: ModelShareMapConditionInput
  ) {
    updateShareMap(input: $input, condition: $condition) {
      id
      name
      shareLat
      shareLon
      tz
      connected
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteShareMap = /* GraphQL */ `
  mutation DeleteShareMap(
    $input: DeleteShareMapInput!
    $condition: ModelShareMapConditionInput
  ) {
    deleteShareMap(input: $input, condition: $condition) {
      id
      name
      shareLat
      shareLon
      tz
      connected
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createHaikuboxUser = /* GraphQL */ `
  mutation CreateHaikuboxUser(
    $input: CreateHaikuboxUserInput!
    $condition: ModelHaikuboxUserConditionInput
  ) {
    createHaikuboxUser(input: $input, condition: $condition) {
      id
      email
      confirmedEmail
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateHaikuboxUser = /* GraphQL */ `
  mutation UpdateHaikuboxUser(
    $input: UpdateHaikuboxUserInput!
    $condition: ModelHaikuboxUserConditionInput
  ) {
    updateHaikuboxUser(input: $input, condition: $condition) {
      id
      email
      confirmedEmail
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteHaikuboxUser = /* GraphQL */ `
  mutation DeleteHaikuboxUser(
    $input: DeleteHaikuboxUserInput!
    $condition: ModelHaikuboxUserConditionInput
  ) {
    deleteHaikuboxUser(input: $input, condition: $condition) {
      id
      email
      confirmedEmail
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createBookmarkHaikubox = /* GraphQL */ `
  mutation CreateBookmarkHaikubox(
    $input: CreateBookmarkHaikuboxInput!
    $condition: ModelBookmarkHaikuboxConditionInput
  ) {
    createBookmarkHaikubox(input: $input, condition: $condition) {
      id
      serial
      owner
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateBookmarkHaikubox = /* GraphQL */ `
  mutation UpdateBookmarkHaikubox(
    $input: UpdateBookmarkHaikuboxInput!
    $condition: ModelBookmarkHaikuboxConditionInput
  ) {
    updateBookmarkHaikubox(input: $input, condition: $condition) {
      id
      serial
      owner
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteBookmarkHaikubox = /* GraphQL */ `
  mutation DeleteBookmarkHaikubox(
    $input: DeleteBookmarkHaikuboxInput!
    $condition: ModelBookmarkHaikuboxConditionInput
  ) {
    deleteBookmarkHaikubox(input: $input, condition: $condition) {
      id
      serial
      owner
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUnclaimHaikubox = /* GraphQL */ `
  mutation CreateUnclaimHaikubox(
    $input: CreateUnclaimHaikuboxInput!
    $condition: ModelUnclaimHaikuboxConditionInput
  ) {
    createUnclaimHaikubox(input: $input, condition: $condition) {
      id
      serial
      owner
      email
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUnclaimHaikubox = /* GraphQL */ `
  mutation UpdateUnclaimHaikubox(
    $input: UpdateUnclaimHaikuboxInput!
    $condition: ModelUnclaimHaikuboxConditionInput
  ) {
    updateUnclaimHaikubox(input: $input, condition: $condition) {
      id
      serial
      owner
      email
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUnclaimHaikubox = /* GraphQL */ `
  mutation DeleteUnclaimHaikubox(
    $input: DeleteUnclaimHaikuboxInput!
    $condition: ModelUnclaimHaikuboxConditionInput
  ) {
    deleteUnclaimHaikubox(input: $input, condition: $condition) {
      id
      serial
      owner
      email
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUserNotice = /* GraphQL */ `
  mutation CreateUserNotice(
    $input: CreateUserNoticeInput!
    $condition: ModelUserNoticeConditionInput
  ) {
    createUserNotice(input: $input, condition: $condition) {
      id
      owner
      noticeID
      noticeViewed
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUserNotice = /* GraphQL */ `
  mutation UpdateUserNotice(
    $input: UpdateUserNoticeInput!
    $condition: ModelUserNoticeConditionInput
  ) {
    updateUserNotice(input: $input, condition: $condition) {
      id
      owner
      noticeID
      noticeViewed
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUserNotice = /* GraphQL */ `
  mutation DeleteUserNotice(
    $input: DeleteUserNoticeInput!
    $condition: ModelUserNoticeConditionInput
  ) {
    deleteUserNotice(input: $input, condition: $condition) {
      id
      owner
      noticeID
      noticeViewed
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createNoticeDescription = /* GraphQL */ `
  mutation CreateNoticeDescription(
    $input: CreateNoticeDescriptionInput!
    $condition: ModelNoticeDescriptionConditionInput
  ) {
    createNoticeDescription(input: $input, condition: $condition) {
      id
      noticeTitle
      noticeDescription
      noticeLink
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateNoticeDescription = /* GraphQL */ `
  mutation UpdateNoticeDescription(
    $input: UpdateNoticeDescriptionInput!
    $condition: ModelNoticeDescriptionConditionInput
  ) {
    updateNoticeDescription(input: $input, condition: $condition) {
      id
      noticeTitle
      noticeDescription
      noticeLink
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteNoticeDescription = /* GraphQL */ `
  mutation DeleteNoticeDescription(
    $input: DeleteNoticeDescriptionInput!
    $condition: ModelNoticeDescriptionConditionInput
  ) {
    deleteNoticeDescription(input: $input, condition: $condition) {
      id
      noticeTitle
      noticeDescription
      noticeLink
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDeleteAccount = /* GraphQL */ `
  mutation CreateDeleteAccount(
    $input: CreateDeleteAccountInput!
    $condition: ModelDeleteAccountConditionInput
  ) {
    createDeleteAccount(input: $input, condition: $condition) {
      id
      owner
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDeleteAccount = /* GraphQL */ `
  mutation UpdateDeleteAccount(
    $input: UpdateDeleteAccountInput!
    $condition: ModelDeleteAccountConditionInput
  ) {
    updateDeleteAccount(input: $input, condition: $condition) {
      id
      owner
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDeleteAccount = /* GraphQL */ `
  mutation DeleteDeleteAccount(
    $input: DeleteDeleteAccountInput!
    $condition: ModelDeleteAccountConditionInput
  ) {
    deleteDeleteAccount(input: $input, condition: $condition) {
      id
      owner
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createOrg = /* GraphQL */ `
  mutation CreateOrg(
    $input: CreateOrgInput!
    $condition: ModelOrgConditionInput
  ) {
    createOrg(input: $input, condition: $condition) {
      id
      owner
      haikuboxName
      lat
      lon
      tz
      publicDirectory
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateOrg = /* GraphQL */ `
  mutation UpdateOrg(
    $input: UpdateOrgInput!
    $condition: ModelOrgConditionInput
  ) {
    updateOrg(input: $input, condition: $condition) {
      id
      owner
      haikuboxName
      lat
      lon
      tz
      publicDirectory
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteOrg = /* GraphQL */ `
  mutation DeleteOrg(
    $input: DeleteOrgInput!
    $condition: ModelOrgConditionInput
  ) {
    deleteOrg(input: $input, condition: $condition) {
      id
      owner
      haikuboxName
      lat
      lon
      tz
      publicDirectory
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSubscription = /* GraphQL */ `
  mutation CreateSubscription(
    $input: CreateSubscriptionInput!
    $condition: ModelSubscriptionConditionInput
  ) {
    createSubscription(input: $input, condition: $condition) {
      id
      owner
      stripeCustomer
      prepaidType
      prepaidPeriodEndUnix
      stripeCurrentPeriodEndUnix
      subscriptionId
      autoRenew
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSubscription = /* GraphQL */ `
  mutation UpdateSubscription(
    $input: UpdateSubscriptionInput!
    $condition: ModelSubscriptionConditionInput
  ) {
    updateSubscription(input: $input, condition: $condition) {
      id
      owner
      stripeCustomer
      prepaidType
      prepaidPeriodEndUnix
      stripeCurrentPeriodEndUnix
      subscriptionId
      autoRenew
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSubscription = /* GraphQL */ `
  mutation DeleteSubscription(
    $input: DeleteSubscriptionInput!
    $condition: ModelSubscriptionConditionInput
  ) {
    deleteSubscription(input: $input, condition: $condition) {
      id
      owner
      stripeCustomer
      prepaidType
      prepaidPeriodEndUnix
      stripeCurrentPeriodEndUnix
      subscriptionId
      autoRenew
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSubscriptionHistory = /* GraphQL */ `
  mutation CreateSubscriptionHistory(
    $input: CreateSubscriptionHistoryInput!
    $condition: ModelSubscriptionHistoryConditionInput
  ) {
    createSubscriptionHistory(input: $input, condition: $condition) {
      id
      owner
      serial
      eventType
      latestInvoice
      stripeCustomer
      subscriptionId
      autoRenew
      datePaidUnix
      unitAmount
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSubscriptionHistory = /* GraphQL */ `
  mutation UpdateSubscriptionHistory(
    $input: UpdateSubscriptionHistoryInput!
    $condition: ModelSubscriptionHistoryConditionInput
  ) {
    updateSubscriptionHistory(input: $input, condition: $condition) {
      id
      owner
      serial
      eventType
      latestInvoice
      stripeCustomer
      subscriptionId
      autoRenew
      datePaidUnix
      unitAmount
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSubscriptionHistory = /* GraphQL */ `
  mutation DeleteSubscriptionHistory(
    $input: DeleteSubscriptionHistoryInput!
    $condition: ModelSubscriptionHistoryConditionInput
  ) {
    deleteSubscriptionHistory(input: $input, condition: $condition) {
      id
      owner
      serial
      eventType
      latestInvoice
      stripeCustomer
      subscriptionId
      autoRenew
      datePaidUnix
      unitAmount
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createFavoriteHit = /* GraphQL */ `
  mutation CreateFavoriteHit(
    $input: CreateFavoriteHitInput!
    $condition: ModelFavoriteHitConditionInput
  ) {
    createFavoriteHit(input: $input, condition: $condition) {
      id
      serial
      owner
      dt
      animalGroup
      cn
      sn
      spCode
      wav
      score
      specSum
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateFavoriteHit = /* GraphQL */ `
  mutation UpdateFavoriteHit(
    $input: UpdateFavoriteHitInput!
    $condition: ModelFavoriteHitConditionInput
  ) {
    updateFavoriteHit(input: $input, condition: $condition) {
      id
      serial
      owner
      dt
      animalGroup
      cn
      sn
      spCode
      wav
      score
      specSum
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteFavoriteHit = /* GraphQL */ `
  mutation DeleteFavoriteHit(
    $input: DeleteFavoriteHitInput!
    $condition: ModelFavoriteHitConditionInput
  ) {
    deleteFavoriteHit(input: $input, condition: $condition) {
      id
      serial
      owner
      dt
      animalGroup
      cn
      sn
      spCode
      wav
      score
      specSum
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUserSettings = /* GraphQL */ `
  mutation CreateUserSettings(
    $input: CreateUserSettingsInput!
    $condition: ModelUserSettingsConditionInput
  ) {
    createUserSettings(input: $input, condition: $condition) {
      id
      owner
      hidePics
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUserSettings = /* GraphQL */ `
  mutation UpdateUserSettings(
    $input: UpdateUserSettingsInput!
    $condition: ModelUserSettingsConditionInput
  ) {
    updateUserSettings(input: $input, condition: $condition) {
      id
      owner
      hidePics
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUserSettings = /* GraphQL */ `
  mutation DeleteUserSettings(
    $input: DeleteUserSettingsInput!
    $condition: ModelUserSettingsConditionInput
  ) {
    deleteUserSettings(input: $input, condition: $condition) {
      id
      owner
      hidePics
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createOfflineApi = /* GraphQL */ `
  mutation CreateOfflineApi(
    $input: CreateOfflineApiInput!
    $condition: ModelOfflineApiConditionInput
  ) {
    createOfflineApi(input: $input, condition: $condition) {
      id
      owner
      okey
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateOfflineApi = /* GraphQL */ `
  mutation UpdateOfflineApi(
    $input: UpdateOfflineApiInput!
    $condition: ModelOfflineApiConditionInput
  ) {
    updateOfflineApi(input: $input, condition: $condition) {
      id
      owner
      okey
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteOfflineApi = /* GraphQL */ `
  mutation DeleteOfflineApi(
    $input: DeleteOfflineApiInput!
    $condition: ModelOfflineApiConditionInput
  ) {
    deleteOfflineApi(input: $input, condition: $condition) {
      id
      owner
      okey
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createTargetFirmware = /* GraphQL */ `
  mutation CreateTargetFirmware(
    $input: CreateTargetFirmwareInput!
    $condition: ModelTargetFirmwareConditionInput
  ) {
    createTargetFirmware(input: $input, condition: $condition) {
      id
      owner
      deviceType
      net
      targetVersion
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTargetFirmware = /* GraphQL */ `
  mutation UpdateTargetFirmware(
    $input: UpdateTargetFirmwareInput!
    $condition: ModelTargetFirmwareConditionInput
  ) {
    updateTargetFirmware(input: $input, condition: $condition) {
      id
      owner
      deviceType
      net
      targetVersion
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTargetFirmware = /* GraphQL */ `
  mutation DeleteTargetFirmware(
    $input: DeleteTargetFirmwareInput!
    $condition: ModelTargetFirmwareConditionInput
  ) {
    deleteTargetFirmware(input: $input, condition: $condition) {
      id
      owner
      deviceType
      net
      targetVersion
      createdAt
      updatedAt
      __typename
    }
  }
`;
